import React, { createContext, useContext, useMemo, useState } from 'react';
const LayoutContext = createContext(undefined);
/**
 * @deprecated layouts should be handled via IA config
 * {@link https://checkout.atlassian.net/wiki/spaces/HUBV/pages/7053869259/Dashboard+Config+Structure}
 */
export const LayoutProvider = ({ children }) => {
    const [isFullPage, setIsFullPage] = useState(false);
    const [isCustomTablePage, setIsCustomTablePage] = useState(false);
    const [bodyWidth, setBodyWidth] = useState(0);
    const values = useMemo(() => ({
        isFullPage,
        setIsFullPage,
        bodyWidth,
        setBodyWidth,
        isCustomTablePage,
        setIsCustomTablePage,
    }), [isFullPage, setIsFullPage, bodyWidth, setBodyWidth, isCustomTablePage, setIsCustomTablePage]);
    return React.createElement(LayoutContext.Provider, { value: values }, children);
};
export function useLayout() {
    const layout = useContext(LayoutContext);
    if (!layout) {
        throw new Error('useLayout needs to be wrapped by LayoutProvider');
    }
    return layout;
}
